import { IconListing } from "../store/store.ts";
export const NO_MOBILE =true
export const MIN_WIDTH = 700
export const DEFAULT_SERVER_ROOT = 'https://apps.trinckle.com';
export const DEFAULT_ASSETS_PATH = `assets`;
export const DEFAULT_LANG_FILE_FOLDER_PATH = `data/lang`;

// window.location might be : 
// https://hosted.trinckle.com/as-staging/apps/outlines/
// https://apps.trinckle.com/apps/outlines/
// https://localhost:1234

export const fullLocation = window.location.toString()
export const hostName = window.location.host.toString()
export const protocol = window.location.protocol // 'http:' or 'https:'
export const localMode = (["localhost","127.0.0.1"].includes(hostName.split(":")[0]));


export const isProduction = window.fakeProduction||(fullLocation.includes("apps.trinckle.com"));


// Get first path segment (e.g., 'as-staging' from '/as-staging/apps/...')
export const pathNameParts = window.location.pathname.split("/").filter(x => x.length);
export const appSuiteRootPath = isProduction ? '' : (pathNameParts[0] || '');

// Full base URL with protocol and optional path prefix
export const fullAppSuiteRootURL = appSuiteRootPath
  ? `${protocol}//${hostName}/${appSuiteRootPath}`
  : `${protocol}//${hostName}`;

// API endpoint
export const apiRoot = appSuiteRootPath
  ? `/${appSuiteRootPath}/user/api.php`
  : '/user/api.php';



export const DEFAULT_ICON_LIST:IconListing = {
  'toggle-workpiece-view': {
    default: 'features/viz-eye-open-blk.svg',
    hidden: 'features/viz-eye-closed-blk.svg'
  },
  'user-options': {
    default: 'user.png',
  },
  'transfer-mesh': {
    default: 'features/next-b.svg'
  },
  'help': {
    default: 'features/question-2.svg'
  } 
}

export const serverCodes = {
  "ERRORCODE_NO_ERROR": -1,
  "ERRORCODE_UNKNOWN_ERROR": 0,
  "ERRORCODE_WRONG_CREDENTIALS": 1,
  "ERRORCODE_NOT_ACTIVE": 2,
  "ERRORCODE_WEAK_PASSWORD": 3,
  "ERRORCODE_PASSWORD_NOT_CONFIRMED": 4,
  "ERRORCODE_ALREADY_EXISTS": 5,
  "ERRORCODE_NOT_ALLOWED": 6,
  "ERRORCODE_NO_ACCESS": 7,
  "ERRORCODE_NOT_FOUND": 8,
  "ERRORCODE_INVALID": 9,
  "ERRORCODE_CAPTCHA": 101,
  "ERRORCODE_EMAIL": 102,

  "-1": "ERRORCODE_NO_ERROR",
  "0": "ERRORCODE_UNKNOWN_ERROR",
  "1": "ERRORCODE_WRONG_CREDENTIALS",
  "2": "ERRORCODE_NOT_ACTIVE",
  "3": "ERRORCODE_WEAK_PASSWORD",
  "4": "ERRORCODE_PASSWORD_NOT_CONFIRMED",
  "5": "ERRORCODE_ALREADY_EXISTS",
  "6": "ERRORCODE_NOT_ALLOWED",
  "7": "ERRORCODE_NO_ACCESS",
  "8": "ERRORCODE_NOT_FOUND",
  "9": "ERRORCODE_INVALID",
  "101": "ERRORCODE_CAPTCHA",
  "102": "ERRORCODE_EMAIL",
};
